
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic04On as ObiLogic04OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-04-on.js';
 
 
 

 
 export const ObiLogic04On = createComponent({
   react: React,
   tagName: 'obi-logic-04-on',
   elementClass: ObiLogic04OnElement,
   events: {
     
   }
  });
 
 